const SortIcon = () => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4553 8.76966L8.22764 0L0 8.76966H16.4553ZM12.6579 7.30855L8.22763 2.92372L3.79736 7.30855H12.6579Z"
        fill="#FFB800"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-2.21215e-05 10.2303L8.22762 19L16.4553 10.2303L-2.21215e-05 10.2303ZM3.79742 11.6914L8.22769 16.0763L12.658 11.6914L3.79742 11.6914Z"
        fill="#FFB800"
      />
    </svg>
  );
};
export default SortIcon;
